const ICON = '/images/icons/calendar_white.svg';

const servicesData = [
  {
    title: 'General Consultations',
    subTitle:
      'Comprehensive examinations, diagnosis, and treatment for everyday illnesses and concerns.',
    iconUrl: ICON,
    href: '/services',
  },
  {
    title: 'Chronic Disease Management',
    subTitle:
      'Ongoing care for hypertension, diabetes, asthma, and other long-term conditions.',
    iconUrl: ICON,
    href: '/services',
  },
  {
    title: 'Preventive Care & Screenings',
    subTitle:
      'Routine check-ups, health screenings, and lifestyle guidance to keep you well.',
    iconUrl: ICON,
    href: '/services',
  },
  {
    title: 'Vaccinations & Immunisations',
    subTitle:
      'Childhood, adult, and travel vaccinations administered safely on-site.',
    iconUrl: ICON,
    href: '/services',
  },
  {
    title: "Women's Health",
    subTitle:
      'Pap smears, family planning, and general well-woman consultations.',
    iconUrl: ICON,
    href: '/services',
  },
  {
    title: "Men's Health",
    subTitle:
      'Routine check-ups, screening tests, and lifestyle advice tailored for men.',
    iconUrl: ICON,
    href: '/services',
  },
  {
    title: 'Paediatric Primary Care',
    subTitle:
      'Well-baby visits, childhood illness consultations, and growth monitoring.',
    iconUrl: ICON,
    href: '/services',
  },
  {
    title: 'Minor Procedures',
    subTitle:
      'Wound care, suturing, removal of skin lesions, and other in-office procedures.',
    iconUrl: ICON,
    href: '/services',
  },
  {
    title: 'Travel & Occupational Medicine',
    subTitle:
      'Pre-travel consultations, medical certificates, and routine medicals.',
    iconUrl: ICON,
    href: '/services',
  },
  {
    title: 'Specialist Referrals',
    subTitle:
      'Coordinated referrals and follow-up care with trusted specialists.',
    iconUrl: ICON,
    href: '/services',
  },
];

export default servicesData;
